import React, { useEffect } from 'react';
import store from 'store2';
import { useNavigate } from 'react-router-dom';
import { AppointmentDispatchTypes, useAppointmentDispatch } from '../../context/Appointment/appointment';
import { useKioskState, useKioskDispatch, usePossibleDealers } from '../../context/Kiosk/kiosk';
import { useLocalization } from '../../context/Localization/localization';
import { hasSavedSession } from '../../context/savedSession';
import { LocalizationButtons } from '../../controls/LocalizationButtons/LocalizationButtons';
import { ThemeImage } from '../../controls/ThemeImage/ThemeImage';
import { formatAsPhoneNumber } from '../../helpers/Number';
import { default as css } from './HomeWeb.module.scss';
import { GMAccessibilityButton } from '../../controls/ButtonBase/index';
import { AppRoutePaths } from '../../helpers/Routes';
import { KioskDispatchTypes } from '../../context/Kiosk/kiosk.types';
import { GMButton } from '../../controls/Button';
import { GMRoundedIcon, GMSizedIcon } from '../../controls/Icon';

export const HomeWeb: React.FC = () => {
    const kiosk = useKioskState();
    const appointmentDispatch = useAppointmentDispatch();
    const kioskDispatch = useKioskDispatch();
    const possibleDealers = usePossibleDealers();
    const navigate = useNavigate();
    const Localization = useLocalization();

    useEffect(() => {
        // Always remove the appointment
        appointmentDispatch({ type: AppointmentDispatchTypes.Remove });
        possibleDealers && kioskDispatch({ type: KioskDispatchTypes.ClearPossibleDealers });
        store.session.remove('tempResult');
        store.session.remove('tempAppointment');
    });

    const onContinue = async () => {
        if (hasSavedSession()) {
            navigate(AppRoutePaths.Landing + AppRoutePaths.ContinueSession);
        }
        else {
            navigate(AppRoutePaths.Landing + AppRoutePaths.Appointment);
        }
    };

    return (
        <div data-testid={'HomeWeb'} className={css.landingPage}>
            <div className={css.expressCheckIn}>
                <div className={css.checkInImage}>
                    <ThemeImage themeImageType={'landingPageBanner'} />
                    <h1 className={css.displayNone}>{Localization.formatString(Localization.MobileCheckInHeader, kiosk.dealer.name) as string}</h1>
                </div>
                {kiosk.dealer.mobileCheckInEnabled ? (
                    <GMButton
                        id={Localization.ClickToBeginCheckIn}
                        title={Localization.ClickToBeginCheckIn}
                        ariaLabel={Localization.ClickToBeginCheckIn}
                        onClick={onContinue}
                        landingPageStyle
                    >
                        <div data-testid={'HomeWeb-MobileCheckInEnabled'} className={css.buttonContent}>
                            <div className={css.leftIcon}>
                                <GMRoundedIcon
                                    themeType={'primary'}
                                    roundedBackgroundSize={'small'}
                                    landingPageStyle
                                >
                                    <GMSizedIcon iconType={'Check-In'} iconSize={'large'} />
                                </GMRoundedIcon>
                            </div>
                            <div className={css.buttonText}>
                                <div className={css.heading}>{Localization.VehicleCheckIn}</div>
                                <div className={css.mainContent}>{Localization.GetStarted}</div>
                            </div>
                            <div className={css.arrowIcon}>
                                <GMSizedIcon
                                    iconType={'Arrow'}
                                    iconSize={'medium'}
                                    ariaLabel={Localization.ProceedArrow}
                                />
                            </div>
                        </div>
                    </GMButton>
                ) : null}
            </div>
            <div className={css.languages}>
                <LocalizationButtons displayAsLinks />
            </div>
            <div className={css.dealerInformation}>
                <div className={css.themeIconBanner}>
                    <ThemeImage themeImageType={'logo'} />
                </div>
                <h2 className={css.dealerName}>{kiosk.dealer.name}</h2>
                <h3 className={css.dealerAddress}>
                    <div>{kiosk.dealer.street}</div>
                    <div>
                        {kiosk.dealer.city}{', '}{kiosk.dealer.stateOrProvince} {kiosk.dealer.postalCode}
                    </div>
                </h3>
                <h4 className={css.dealerNumber}>
                    <a href={'tel:' + kiosk.dealer.phone} title={Localization.ClickToCallOurDealership}>
                        {formatAsPhoneNumber(kiosk ? kiosk.dealer.phone : '')}
                    </a>
                </h4>
            </div>
            <GMAccessibilityButton onLandingPage />
        </div>
    );
};

export { HomeWeb as default };